export default {
    "messages": {
        "no-data": "Actuellement pas de données disponible",
        "latina": {
            "player": {
                "share": "[not used](FR) Partilhar",
                "share-message": "[not used](FR) Estou a ouvir {song}-{artist} na Rádio Latina",
                "no-track-info": "[not used](FR) Sem informação da música",
                "no-artist": "[not used](FR) Sem artista",
                "last-tracks": {
                    "title": "[not used](FR) Últimas Músicas"
                }
            }
        },
        "service": {
            "traffic":{
                "alert": {
                    "title": "Infos trafic",
                    "none": "Aucune alerte trafic"
                },
                "trafficcamera": {
                    "title": "Web Cam"
                },
                "parking": {
                    "title": "Parking",
                    "defaultDistrict": "Centre",
                    "column": {
                        "carParks": "Parking",
                        "capacity": "Capacité",
                        "occupied": "Occupation",
                        "free": "Libre",
                        "trend": "Tendance"
                    },
                    "closed": "fermé"
                },
                "no-data": "pas de données"
            },
            "sport-results": {
                "sport-name": {
                    "footballNational": "Football national",
                    "footballInternational": "Football international",
                    "basketball": "Basketball",
                    "handball": "Handball",
                    "volleyball": "Volleyball",
                    "tableTennis": "Tennis de table"
                },
                "title": {
                    "prefix": "Résultats pour la",
                    "day": "e",
                    "suffix": "journée",
                    "mobile-prefix": "Résultats ",
                    "mobile-suffix": "journée"
                },
                "ranking": {
                    "title": "Classement après la dernière journée",
                    "mobile-title": "Classement (dernière journée)",
                    "position": "Pos.",
                    "team": "Equipe",
                    "played": "J.",
                    "won": "G.",
                    "draw":"N.",
                    "lost": "P.",
                    "difference": "Diff.",
                    "points": "Pts"
                }
            },
            "commons": {
                "luxembourgCitySouth": "Luxembourg Ville (Sud)",
                "germanyBorder": "Allemagne",
                "franceBorder": "France",
                "luxembourgCityHollerich": "Luxembourg Hollerich",
                "eschSurAlzette": "Esch-sur-Alzette",
                "belgiumBorder": "Belgique",
                "grunewald": "Grunewald",
                "colmarBerg": "Colmar-Berg",
                "sarrebruck": "Sarrebruck",
                "longwy": "Longwy",
                "no-data": "Actuellement pas de données disponible"
            },
            "events": {
                "countries": {
                    "lu": "Luxembourg",
                    "de": "Allemagne",
                    "fr": "France",
                    "be": "Belgique",
                    "none": ""
                },
                "upcoming": "En ce moment",
                "permanents": "Rendez-vous récurrents",
                "timeFromFormat": "de",
                "timeToFormat": "à",
                "dateStartFormat": "[Du] ll",
                "dateStartingFromFormat": "[À partir du] ll",
                "dateEndFormat": " [au] ll",
                "allEvents": "Tous les événements",
                "no-events": "Aucun événement à venir",
                "categories": {
                    "all": "Tous",
                    "concerts": "Concerts",
                    "nightlife": "Nightlife",
                    "dance": "Danse",
                    "opera_theatre": "Opéra & Théâtre",
                    "sport": "Sport",
                    "spectacle": "Spectacles",
                    "festivity_festival": "Fêtes & Festivals",
                    "conference_seminar": "Conférences & Séminaires",
                    "exhibition": "Expositions",
                    "family_kids": "Famille",
                    "other": "Autres"
                },
                "event-details": {
                    "show-more-dates": "Afficher plus de dates",
                    "show-map": "Afficher la carte",
                    "free": "Gratuit",
                    "fallback-description": "La description n'est pas disponible dans votre langue",
                    "no-description": "La description n'est pas disponible",
                    "canceled": "canceled",
                    "monday": "Lundi",
                    "tuesday": "Mardi",
                    "wednesday": "Mercredi",
                    "thursday": "Jeudi",
                    "friday": "Vendredi",
                    "saturday": "Samedi",
                    "sunday": "Dimanche",
                    "closed": "fermé"
                }
            }
        },
        "commons": {
            "delete": "Supprimer",
            "show-more": "Afficher plus"
        },
        "share-buttons": {
            "copy-to-clipboard-message": "Le lien a été copié dans votre presse-papiers."
        },
        "homepage": {
            "new-articles": "Nouveaux articles disponibles"
        },
        "notifications-page": {
            "subscription": {
                "success": {
                    "subscribe": "Souscription réussie !",
                    "unsubscribe": "Vous vous êtes désinscrit avec succès."

                },
                "fail": "Désolé, nous n'avons pas pu vous enregistrer. Rafraichissez la page et essayez encore une fois, s'il vous plaît."
            },
            "permission": {
                "blocked": "Vous ne pouvez pas vous abonner aux notifications push du wort.lu car vous les avez bloqué. Veuillez les autoriser dans les paramètres de votre navigateur pour pouvoir les recevoir."
            },
            "unsupported-browser": "Désolé, votre navigateur ne supporte pas les notifications push."
        },
        "services": {
            "announcements": {
                "births": "Naissances",
                "weddings": "Mariages",
                "obituaries": "Avis de décès"
            }
        },
    }
};



// WEBPACK FOOTER //
// ./js/i18n/TranslationFrench.js